import { FunctionComponent, PropsWithChildren } from 'react';
import type { Store } from 'redux';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { browserHistory } from '@cbridge-utils/app';
import { Provider } from '@cbridge-utils/react-redux';

interface StoreProviderProps extends PropsWithChildren {
  store: Store;
}

export const StoreProvider: FunctionComponent<StoreProviderProps> = ({ store, children }) => (
  <Provider store={store}>
    <ReduxRouter history={browserHistory}>
      {children}
    </ReduxRouter>
  </Provider>
);
